import { merge } from 'lodash-es';

export function mergeDeep<TObject, TSource>(object: TObject, source: TSource): TObject & TSource {
  return merge(object, source);
}
